<template>
  <div class="ws-datepicker">
    <b-datepicker
      v-bind="$attrs"
      v-model="newValue"
      @input="onInput"
      :focused-date="focusedDate"
      :open-on-focus="false"
      icon="date"
      :position="position"
      :years-range="getYearsRange()"
      :years-to-show="10"
      :min-date="minDate"
      :max-date="maxDate"
      :events="events"
      @focus="onFocus"
      @change-year="changeYear"
      placeholder="дд.мм.гггг"
      v-mask="'##.##.####'"
      ref="datepicker"
      :disabled="disabled"
      editable
      class="ws-field__control">
      <button
        type="button"
        class="button is-outlined"
        @click.prevent="setToday"
      >
        Сегодня
      </button>
    </b-datepicker>
    <button
      type="button"
      class="ws-field__clear ws-button button is-text"
      v-if="newValue && !disabled"
      @click="clear()">
      <ws-icon
        class="ws-button__icon"
        name="close-thin"
        color="#000000"
        :fill="false"
        width="17"
        height="11"
      />
    </button>
    <button
      v-if="!disabled"
      class="ws-button button is-text ws-datepicker__toggle"
      type="button"
      @click="onFocus">
      <ws-icon
        class="ws-button__icon"
        name="datepicker"
        color="#000000"
        :fill="true"
        width="15"
        height="15"
      />
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WsDatepicker',
  props: {
    position: {
      type: String
    },
    minDate: Date,
    maxDate: Date,
    focusedDate: Date,
    disabled: Boolean,
    value: Date
  },
  data () {
    return {
      newValue: this.value,
      currentYear: this.value ? new Date(this.value).getFullYear() : new Date().getFullYear()
    }
  },
  watch: {
    // нужно для случая, когда есть value, чтобы изначально подгрузить данные,
    // если делать при открытии, то фокус в библиотке сбрасывается и дропдаун закрывается с календарем,
    // другого решения пока нет, если только менять календярь, мб в версии выше это поправлено
    // можно было бы сделать пременную, которая отвечает за isOpen дропдауна и прокидывать его,
    // но его нет у библиотеки
    value: {
      immediate: true,
      handler (value) {
        if (this.value) {
          this.changeYear(this.currentYear)
        }
        this.newValue = value
      }
    }
  },
  computed: {
    ...mapGetters('calendarGeneral', ['datesCalendar']),
    events () {
      return this.datesCalendar && this.datesCalendar[this.currentYear]
        ? this.datesCalendar[this.currentYear].list : []
    }
  },
  methods: {
    ...mapActions('calendarGeneral', ['getDatesCalendar']),
    // кейс для подгрузки данных без value
    onFocus () {
      this.changeYear(this.currentYear)
      this.$refs.datepicker.toggle()
    },
    async changeYear (year) {
      // isLoading - нужно для исключения идентичных запросов (например, на странице уже есть несколько дат с одинаковым годом) (см. коммент в watch value)
      const isLoading = this.datesCalendar && this.datesCalendar[year]
        ? this.datesCalendar[this.currentYear].isLoading : false
      this.currentYear = year
      if (!isLoading) {
        await this.getDatesCalendar(year)
      }
    },
    onInput (value) {
      this.$emit('input', value)
    },
    setToday () {
      this.$emit('input', new Date())
    },
    clear () {
      this.newValue = null
      this.$emit('input', null)
    },
    getYearsRange () {
      const MIN_YEAR = 1900
      const MAX_YEAR = new Date().getFullYear() + 27
      let max = 4
      let min = -1
      const currentYear = this.currentYear
      const pastYear = currentYear + min
      const futureYear = currentYear + max

      if (pastYear <= MIN_YEAR) {
        min = (currentYear - MIN_YEAR) * -1
      }

      if (futureYear >= MAX_YEAR) {
        max = MAX_YEAR - currentYear
      }

      if (currentYear < MIN_YEAR || currentYear > MAX_YEAR) {
        min = 0
        max = 0
      }

      return [min, max]
    }
  },
  mounted () {
    this.$refs.datepicker.onInputClick = event => {
      event.stopPropagation()
    }
  }
}
</script>

<style lang="scss">
.datepicker .datepicker-table .datepicker-cell {
  display: table-cell;
  padding: 0.5rem 0.75rem !important;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
}

.events {
  display: none !important;
}

.datepicker .datepicker-table .datepicker-body .datepicker-cell.is-selectable:has(> .events) {
  color: #eb5757 !important;
}
</style>
